import React from 'react';
import { Button } from 'antd-v5';
import NewPopConfirm from '../../../../Layout/NewPopConfirm';
import './styles.css';

const SetPrimaryAccountModal = ({ name, onCancel, onConfirm }) => {
  return (
    <NewPopConfirm className="cb-primary-bank-account-modal">
      <h3 className="cb-primary-bank-account-modal__title">Set as Default Account</h3>

      <p className="cb-primary-bank-account-modal__subtitle">
        All new stores will be assigned to <br />
        {name}
      </p>

      <p className="cb-primary-bank-account-modal__description">
        Any new stores will be automatically linked to this account.
      </p>
      <div className="flex-row-center" style={{ gap: '12px' }}>
        <Button size="large" onClick={onCancel}>
          Cancel
        </Button>
        <Button type="primary" size="large" onClick={onConfirm}>
          Confirm
        </Button>
      </div>
    </NewPopConfirm>
  );
};

export default SetPrimaryAccountModal;
